const Divider = () => {
  return <hr className="h-5 w-[1px] bg-[#DADADC] sm:inline-block" />;
};

export default Divider;
